<template>
    <d-container fluid class="main-content-container px-4">
        <div class="page-header row no-gutters py-4">
            <div class="col-12 text-center text-sm-left mb-0">
                <h3 class="page-title">Add new domain</h3>
            </div>
        </div>

        <d-row v-if="checkPermission(permissionTypes.websiteWrite)">
            <d-col lg="12">
                <d-card >
                    <d-card-header class="border-bottom">
                        <d-row class="d-flex justify-content-center">
                            <d-col cols="2" class="progress-text d-none d-xl-block">
                                <h6 class="m-0 text-center bar-text"><d-link class="text-dark" :to="{ name: 'add-domain' }">1. Add website</d-link></h6>
                            </d-col>
                            <d-col cols="2" class="progress-text d-none d-xl-block">
                                <h6 class="m-0 text-center bar-text">2. Connect networks</h6>
                            </d-col>
                            <d-col cols="2" class="progress-text d-none d-xl-block">
                                <h6 class="m-0 text-center bar-text">3. Connect integrations</h6>
                            </d-col>
                            <d-col cols="2" class="progress-text d-none d-xl-block">
                                <h6 class="m-0 text-center bar-text">4. Place Ivanhoe.io tag</h6>
                            </d-col>
                            <d-col cols="2" class="progress-text d-none d-xl-block">
                                <h6 class="m-0 text-center bar-text">5. Choose direct or cloaked links</h6>
                            </d-col>
                            <d-col cols="2" class="progress-text pl-0 pr-0 d-none d-xl-block">
                                <h6 class="m-0 text-center bar-text">6. Ready to start</h6>
                            </d-col>
                        </d-row>
                        <d-progress :value="percent" :max="100" />
                    </d-card-header>
                    <d-card-body>
                        <d-row>
                            <d-col lg="6" class="ml-5">
                                <d-col class="mt-2">
                                    <p>This will get you started in 5 minutes.</p>
                                    <i class="fa fa-smile-o" style="font-size:80px"></i>
                                    <h4>Enter your website</h4>
                                    <P>Enter your website information here and we will set all things up for you.</P>
                                </d-col>
                            </d-col>
                            <d-col lg="5">
                                <d-form id="domainForm" @submit.prevent="createWebsite">
                                    <d-form-row class="mt-3">
                                        <d-col>
                                            <d-col cols="12" class="form-group">
                                                <label for="url">URL:</label>
                                                <d-form-input required v-model="websiteName" type="text" id="url" placeholder="https://example.com/" />
                                            </d-col>

                                            <d-col cols="12" class="form-group">
                                                <label for="currency">Currency:</label>
                                                <d-form-select v-model="currencyId">
                                                    <option v-for="currency in currencies" :value="currency.id">{{ currency.name }}</option>
                                                </d-form-select>
                                            </d-col>
                                            <d-col cols="12" class="form-group d-flex justify-content-end">
                                                <input value="Next" type="submit" class="btn btn-success"/>
                                            </d-col>
                                        </d-col>
                                    </d-form-row>
                                </d-form>
                            </d-col>
                        </d-row>
                    </d-card-body>
                </d-card>
            </d-col>
        </d-row>
        <no-permission-message v-else />
    </d-container>
</template>

<script>
    import { WebsiteService, CurrencyResource, ErrorService } from '@/main';
    import notification from '@/mixins/notification';
    import permissions from '../../../mixins/permissions';
    import * as Sentry from "@sentry/browser";

    export default {
        mixins: [notification, permissions],

        data() {
            return {
                percent: 5,
                websiteName: '',
                currencies: [],
                currencyId: 1,
            };
        },
        methods: {
            async getCurrencies() {
                try {
                    const currencyInfo = await CurrencyResource.get()
                    this.currencies = currencyInfo.data.currencies
                } catch (e) {
                    this.showNotification('warn', 'Oops! We have a problem', 'Can not get currencies')
                    console.log(e)
                }
            },

            async createWebsite() {
                try {
                    const website = await WebsiteService.create(this.websiteName, this.currencyId)
                    this.showNotification('success', 'Alert', 'Domain successfully added!')
                    this.$router.push('add-network/' + website.id)
                    this.$router.go()
                } catch (e) {
                    let message = ErrorService.getErrorMessage(e.networkError.result.errors[0])
                    if (message === 'This domain already added!') {
                        message += ' Please, contact us via bart@ivanhoe.io OR signup with a different domain'
                    } else {
                        Sentry.captureException(e);
                    }

                    this.showNotification('warn', 'Oops! We have a problem', message)
                    console.log(e)
                }
            },
        },

        created () {
            this.getCurrencies()
        },
    };
</script>
